const STORAGE_PREFIX = 'soluqr_mesa_context_';

/** Normaliza número/nombre de mesa desde QR o URL (?mesa=12). */
export function normalizeTableNumber(raw) {
  const s = String(raw ?? '').trim();
  if (!s) return '';
  if (!/^[a-zA-Z0-9][a-zA-Z0-9\s\-_.]{0,14}$/.test(s)) return '';
  return s;
}

export function parseMesaFromSearchParams(searchParams) {
  if (!searchParams) return '';
  const keys = ['mesa', 'table', 'table_number'];
  for (const key of keys) {
    const value = normalizeTableNumber(
      typeof searchParams.get === 'function' ? searchParams.get(key) : null,
    );
    if (value) return value;
  }
  return '';
}

export function businessSupportsTableService(business) {
  return Boolean(
    business?.has_tables &&
      Array.isArray(business?.service_types) &&
      business.service_types.includes('mesa'),
  );
}

export function readMenuTableContext(businessId) {
  if (!businessId) return null;
  try {
    const raw = sessionStorage.getItem(`${STORAGE_PREFIX}${businessId}`);
    if (!raw) return null;
    const data = JSON.parse(raw);
    const tableNumber = normalizeTableNumber(data?.tableNumber);
    if (!tableNumber) return null;
    return {
      tableNumber,
      source: data?.source === 'url' ? 'url' : 'session',
    };
  } catch {
    return null;
  }
}

export function saveMenuTableContext(businessId, tableNumber, source = 'url') {
  const normalized = normalizeTableNumber(tableNumber);
  if (!businessId || !normalized) return null;
  const ctx = {
    tableNumber: normalized,
    source: source === 'session' ? 'session' : 'url',
    savedAt: new Date().toISOString(),
  };
  sessionStorage.setItem(`${STORAGE_PREFIX}${businessId}`, JSON.stringify(ctx));
  return ctx;
}

/** Lee ?mesa= de la URL y persiste en sesión; si no hay param, devuelve lo guardado. */
export function syncMenuTableContextFromSearchParams(businessId, searchParams) {
  const fromUrl = parseMesaFromSearchParams(searchParams);
  if (fromUrl) return saveMenuTableContext(businessId, fromUrl, 'url');
  return readMenuTableContext(businessId);
}

export function getMenuTableCheckoutPatch(businessId, business) {
  if (!businessSupportsTableService(business)) return null;
  const ctx = readMenuTableContext(businessId);
  if (!ctx?.tableNumber) return null;
  return {
    serviceType: 'mesa',
    service_type: 'mesa',
    tableNumber: ctx.tableNumber,
  };
}

export function hasActiveMesaQrContext(businessId, business) {
  return getMenuTableCheckoutPatch(businessId, business) != null;
}

export function applyMenuTableContextToCheckoutBootstrap(bootstrap, businessId, business) {
  const patch = getMenuTableCheckoutPatch(businessId, business);
  if (!patch) return bootstrap;
  if (!bootstrap) {
    return { mode: 'change', order: { ...patch } };
  }
  return {
    ...bootstrap,
    order: { ...(bootstrap.order || {}), ...patch },
  };
}
